<template>
  <div class="accent">
    <v-container fluid align="center" justify="center" class="py-2">
      <v-row no-gutters>
        <v-col cols="12">
          <v-card elevation="0" class="tm-main-card tw-mt-2 md:tw-mt-4">
            <div class="tm-header">
              <div class="tm-badge">
                <v-icon color="white">mdi-account-group</v-icon>
              </div>
              <h2 class="tm-title">APA Staff</h2>
            </div>
            <v-divider class="mb-3" />
            <div class="tm-table">
              <app-team-table />
            </div>
          </v-card>
        </v-col>
      </v-row>
      <app-invite-user />
    </v-container>
  </div>
</template>

<script>
export default {
  components: {
    appTeamTable: () => import('@/components/team-managment/UsersTable'),
    appInviteUser: () => import('@/components/team-managment/InviteUser'),
  },
  props: {
    source: String,
  },
  data: () => ({
    dialog: false,
    drawer: null,
    snackback: false,
  }),
}
</script>

<style scoped>
/* Soft-edged main card (matches BidSubmitted / BidDetails design language) */
.tm-main-card {
  border-radius: 18px;
  border: 1px solid #e8edf5;
  background: #ffffff;
  padding: 18px 20px 20px;
}
.tm-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
}
.tm-badge {
  flex: 0 0 auto;
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: linear-gradient(135deg, #034ea2 0%, #0a63c4 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 6px 16px rgba(3, 78, 162, 0.25);
}
.tm-title {
  font-size: 20px;
  font-weight: 800;
  color: #0f2a55;
  margin: 0;
}
/* Frame the table with the same soft edges; drop the harsh default elevation */
.tm-table {
  border-radius: 12px;
  border: 1px solid #eef2f8;
  overflow: hidden;
}
.tm-table ::v-deep .v-data-table.elevation-1 {
  box-shadow: none !important;
}
</style>
